// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2JhQ1","title":"InfoRow_title__jR28H"};